export default __webpack_public_path__ + "static/media/776.100a8735.png";